import React from "react";
import { Link, Navigate, useParams } from "react-router-dom";
import Profile from "./Profile";
import Password from "./Password";

function Settings() {
  let { option } = useParams();

  if(option !== "profile" && option !== "password") {
    Navigate({to: "/settings/profile", replace: true});
  }

  return (
    <div>
      <div className="taps"style={{margin: "32px"}}>
        <Link to="/settings/profile" style={{margin: "16px"}}>Edit Profile</Link>
        <Link to="/settings/password" style={{margin: "16px"}}>Change password</Link>
      </div>
      {option === "profile" && <Profile />}
      {option === "password" && <Password />}
    </div>
  );
}

export default Settings;
